// extracted by mini-css-extract-plugin
export default {"page_hero_wrapper":"PageHero_page_hero_wrapper__fZEKI","page_hero_content":"PageHero_page_hero_content__k7aXZ"};